module.exports = __webpack_public_path__ + "media/hyper/images/users/avatar-2-ebcf91db37270a3f49208449a2313d24.jpg";